module.exports = __webpack_public_path__ + "img/scene1.0638555a.png";